/**
 * Cascade's binding to the shared notification settings surface.
 *
 * The component in @command-center/oneup-portal-ui is transport-agnostic; this
 * is the only Cascade-specific part, and it is deliberately nothing more than
 * this portal's authenticated fetch behind the shared interface.
 */

import type {
  NotificationDelivery,
  NotificationDraft,
  NotificationFormOption,
  NotificationPreview,
  NotificationSettingsClient,
  NotificationSettingsPayload,
} from '@command-center/oneup-portal-ui';
import { request } from './api';

export const notificationsClient: NotificationSettingsClient = {
  load: () => request<NotificationSettingsPayload>('/api/notifications/settings'),
  save: (draft: NotificationDraft) =>
    request('/api/notifications/settings', { method: 'PUT', body: JSON.stringify(draft) }),
  preview: (draft: NotificationDraft) =>
    request<NotificationPreview>('/api/notifications/preview', {
      method: 'POST',
      body: JSON.stringify(draft),
    }),
  sendTest: (draft) =>
    request<{ to: string }>('/api/notifications/test', {
      method: 'POST',
      body: JSON.stringify(draft),
    }),
  listForms: async () =>
    (await request<{ forms: NotificationFormOption[] }>('/api/notifications/forms')).forms,
  listDeliveries: async ({ status }) =>
    (
      await request<{ deliveries: NotificationDelivery[] }>(
        `/api/notifications/deliveries${status && status !== 'all' ? `?status=${status}` : ''}`,
      )
    ).deliveries,
};
